import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { PaginaCreacionLibre } from "../../Componentes/Compuestos/Paginas/PaginaCreacionLibre";
import * as XLSX from 'xlsx';
import { GroupItem } from 'devextreme-react/form';
import { LVForm } from "../../Componentes/Basicos/LVForm"
import LVButtonAccion from "../../Componentes/Basicos/LVButtonAccion";
import { TextBox } from "devextreme-react";
import { ConversionDeExcelToJson } from "neftis7_apicaller/src/funciones/Varios";
import { function_CON_OperacionesParaImportar_Importar } from "neftis7_apicaller/src/funciones/CONT/CON_OperacionesParaImportar";

export const CON_OperacionesParaImportar_Importacion = () => {

  const [data, setData] = useState([]);
  const [columnaFecha, setColumnaFecha] = useState("Fecha");
  const [columnaCantidad, setColumnaCantidad] = useState("Cantidad");
  const [columnaCuotas, setColumnaCuotas] = useState("Cuotas");
  const [columnaDescripcion, setColumnaDescripcion] = useState("Descripcion");
  const [columnaCodigoCuentaFinanciera, setColumnaCodigoCuentaFinanciera] = useState("CodigoCuentaFinanciera");
  const [columnaCodigoArticulo, setColumnaCodigoArticulo] = useState("CodigoArticulo");
  const [columnaCodigoPresentacion, setColumnaCodigoPresentacion] = useState("CodigoPresentacion");
  const [columnaCodigoTamano, setColumnaCodigoTamano] = useState("CodigoTamano");
  const [columnaCodigoUnidadMedida, setColumnaCodigoUnidadMedida] = useState("CodigoUnidadMedida");
  const [columnaImporteNeto, setColumnaImporteNeto] = useState("ImporteNeto");
  const [columnaImporteIVA105, setColumnaImporteIVA105] = useState("ImporteIVA105");
  const [columnaImporteIVA21, setColumnaImporteIVA21] = useState("ImporteIVA21");
  const [cierreEnProceso, setCierreEnProceso] = useState(false);


  useEffect(() => {
    const user = localStorage.getItem("user");
    const codigoCompania = localStorage.getItem("CodigoCompania");
    const codigoEmpresa = localStorage.getItem("CodigoEmpresa");
    const codigoPlanta = localStorage.getItem("CodigoPlanta");
    const idPersona = localStorage.getItem("IdPersona");

    if (!user || !codigoCompania || !codigoEmpresa || !codigoPlanta || Number(idPersona) < 1) {
      if (![-1, -2, -3].includes(Number(idPersona))) {
        return <Navigate to={"/Login"} />;
      }
    }
  }, []);

  const handleFileUpload = (e) => {
    try {
      const file = e.target.files[0];
      const reader = new FileReader();
      reader.onload = (evt) => {
        const bstr = evt.target.result;
        const wb = XLSX.read(bstr, { type: 'binary' });
        const wsname = wb.SheetNames[0];
        const ws = wb.Sheets[wsname];

        setData(ConversionDeExcelToJson(ws));
      };
      reader.readAsBinaryString(file);
    } catch (error) {
      alert("Se han producido errores: " + error)
    }
  };

  const handleImportarClick = async () => {
    try {
      if (cierreEnProceso) return; // si ya está ejecutando, no hace nada
      setCierreEnProceso(true);

      await function_CON_OperacionesParaImportar_Importar(columnaFecha,
        columnaCantidad,
        columnaCuotas,
        columnaDescripcion,
        columnaCodigoCuentaFinanciera,
        columnaCodigoArticulo,
        columnaCodigoPresentacion,
        columnaCodigoTamano,
        columnaCodigoUnidadMedida,
        columnaImporteNeto,
        columnaImporteIVA105,
        columnaImporteIVA21,
        data
      );

      alert("Se han importado los registros.")
    } catch (error) {
      alert("Se han producido errores: " + error)
    } finally {
      setCierreEnProceso(false); // Se habilita el botón de nuevo
    }
  };

  return (
    <PaginaCreacionLibre Titulo="IMPORTACIÓN DE OPERACIONES">
      <div>
        <div>
          <h3>Seleccionar Planilla</h3>
          <input type="file" onChange={handleFileUpload} />
          <div style={{ marginTop: '20px' }}>
            <strong>IMPORTANTE:</strong>
            <p>La Planilla debe contener en la primera fila los títulos de las columnas.</p>
            <p>En la primera fila no debe haber celdas vacías.</p>
          </div>
        </div>

        <div>
          <h3>Seleccionar columnas de la Planilla</h3>
          <p><strong>IMPORTANTE:</strong> Los nombres de las columnas deben respetar mayúsculas y minúsculas.</p>
          <p>Las columnas que no se desean importar se dejarán con el título vacío.</p>

          <p>Los registros con IMPORTE NETO negativos seran egresos.</p>
          <p>Los registros con IMPORTE NETO positivo seran ingresos.</p>

          <TextBox label="Título Fecha" value={columnaFecha} onValueChanged={(e) => setColumnaFecha(e.value)} />
          <TextBox label="Título Código Cuenta Financiera" value={columnaCodigoCuentaFinanciera} onValueChanged={(e) => setColumnaCodigoCuentaFinanciera(e.value)} />
          <TextBox label="Título Cantidad" value={columnaCantidad} onValueChanged={(e) => setColumnaCantidad(e.value)} />
          <TextBox label="Título Cuotas" value={columnaCuotas} onValueChanged={(e) => setColumnaCuotas(e.value)} />
          <TextBox label="Título Descripcion" value={columnaDescripcion} onValueChanged={(e) => setColumnaDescripcion(e.value)} />
          <TextBox label="Título Código Artículo" value={columnaCodigoArticulo} onValueChanged={(e) => setColumnaCodigoArticulo(e.value)} />
          <TextBox label="Título Código Presentación" value={columnaCodigoPresentacion} onValueChanged={(e) => setColumnaCodigoPresentacion(e.value)} />
          <TextBox label="Título Código Tamaño" value={columnaCodigoTamano} onValueChanged={(e) => setColumnaCodigoTamano(e.value)} />
          <TextBox label="Título Código U. Medida" value={columnaCodigoUnidadMedida} onValueChanged={(e) => setColumnaCodigoUnidadMedida(e.value)} />
          <TextBox label="Título Importe Neto" value={columnaImporteNeto} onValueChanged={(e) => setColumnaImporteNeto(e.value)} />
          <TextBox label="Título Importe I.V.A. 10.5%" value={columnaImporteIVA105} onValueChanged={(e) => setColumnaImporteIVA105(e.value)} />
          <TextBox label="Título Importe I.V.A. 21%" value={columnaImporteIVA21} onValueChanged={(e) => setColumnaImporteIVA21(e.value)} />
        </div>

        <div style={{ marginTop: '20px' }}>
          <LVButtonAccion
            Disabled={cierreEnProceso} Texto="IMPORTAR" onClick={handleImportarClick} />
        </div>
      </div>
    </PaginaCreacionLibre>
  );
};